<div mat-dialog-title style="display: flex">
  <span>
    {{caption}}
  </span>

  <span style="flex: auto"></span>

  <button
    mat-icon-button
    type="button"
    [mat-dialog-close]="false"
    matTooltip="Close"
    color="primary"
    style="margin: -1em">
    <mat-icon aria-label="Close">close</mat-icon>
  </button>
</div>

<div mat-dialog-content>
  <kendo-upload
    [autoUpload]="true"
    [batch]="false"
    [withCredentials]="false"
    [saveField]="'files'"
    [saveMethod]="'PUT'"
    [saveUrl]="saveUrl"
    [responseType]="'text'"
    [concurrent]="false"
    [multiple]="false"
    [disabled]="uploadDisabled"
    [showFileList]="false"
    (select)="uploader_select($event)"
    (upload)="uploader_upload($event)"
    (success)="uploader_success($event)"
  ></kendo-upload>

  <div *ngIf="files?.length">
    <br />
    <div *ngFor="let file of files">
      {{ file.name }}
    </div>
  </div>

  <div *ngIf="processing">
    <br />
    <dx-load-indicator height="20" width="20"></dx-load-indicator>
    Processing Uploaded File
  </div>

  <div *ngIf="done">
    <br />
    Done!
    <br />
    {{ response }}
  </div>

  <div *ngIf="error" style="color: #ce312c ">
    <br />
    Error: {{ error }}
  </div>
</div>

<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="imported">Close</button>
</div>
